<h1 class="mc-tt">Mis datos</h1>
<p class="cf-sub">Cuanto más completo esté tu perfil, mejor te podemos avisar lo que necesitás.</p>

<div class="mc-blk">

  <div class="mc-hd"><h2>Datos personales</h2></div>

  <!-- Hasta que llegue el modelo no se pinta: el binding del email escribe
       sobre model y sin la guarda romperia en el primer ciclo. -->
  <div class="cf-fields" *ngIf="model">

    <!-- No editables: se muestran como dato en lectura, no como campo gris con
         candado. Es la nota B1 del brief. -->
    <div class="cf-f">
      <label>Nombre y apellido</label>
      <div class="cf-ro">{{ nombreCompleto || '—' }}</div>
      <div class="cf-hint">Para cambiarlo necesitamos verificar tu documento.</div>
    </div>

    <div class="cf-f">
      <label>DNI</label>
      <div class="cf-ro">{{ model?.dni || '—' }}</div>
      <div class="cf-hint">Es con lo que te identificás en la caja.</div>
    </div>

    <div class="cf-f">
      <label for="cfTel">Teléfono</label>
      <div class="cf-telrow">
        <select [(ngModel)]="telPrefijo" name="telPrefijo" aria-label="Código de país">
          <option *ngFor="let p of prefijos" [value]="p">{{ p }}</option>
        </select>
        <input id="cfTel" type="tel" [(ngModel)]="telNumero" name="telNumero"
               placeholder="11 5544-8890" maxlength="20">
      </div>
    </div>

    <!-- No editable: se muestra en lectura, igual que nombre y DNI. El valor
         sigue en el modelo, asi que edit() lo guarda sin cambios. -->
    <div class="cf-f">
      <label>Correo electrónico</label>
      <div class="cf-ro">{{ model?.emailPrincipal || model?.emails?.[0]?.email || '—' }}</div>
      <div class="cf-hint">Para cambiarlo, comunicate con atención al cliente.</div>
    </div>

    <!-- Tienda habitual: se puede elegir de la lista o escribir el nombre, la
         calle o la ciudad y va filtrando. -->
    <div class="cf-f cf-f-ancho">
      <label for="cfTienda">Mi tienda habitual</label>

      <div class="cf-combo">
        <input id="cfTienda" [(ngModel)]="tiendaTexto" name="tiendaTexto"
               (input)="alEscribirTienda()" (focus)="abrirLista()" (blur)="cerrarLista()"
               placeholder="Elegí, o escribí el nombre o la calle para buscar"
               autocomplete="off">

        <button type="button" class="cf-limpiar" *ngIf="tiendaTexto" (click)="limpiarTienda()"
                aria-label="Borrar">×</button>

        <div class="cf-opciones" *ngIf="listaAbierta && tiendasFiltradas.length > 0">
          <button type="button" *ngFor="let t of tiendasFiltradas"
                  [class.sel]="tiendaElegida?.storeCode === t.storeCode"
                  (click)="elegirTienda(t)">
            <b>{{ t.nombre }}</b>
            <span *ngIf="descripcion(t)">{{ descripcion(t) }}</span>
          </button>
        </div>

        <div class="cf-opciones cf-vacio" *ngIf="listaAbierta && tiendasFiltradas.length === 0">
          No encontramos ninguna sucursal con eso.
        </div>
      </div>

      <div class="cf-hint" *ngIf="tiendaElegida">
        Elegiste <b>{{ tiendaElegida.nombre }}</b>. Es opcional. La usamos para avisarte
        de cosas de tu sucursal.
      </div>
      <div class="cf-hint" *ngIf="!tiendaElegida">
        Es opcional. La usamos para avisarte de cosas de tu sucursal.
      </div>
    </div>

  </div>

  <div class="cf-acts">
    <button class="cf-btn" [disabled]="!puedeGuardar" (click)="edit()">Guardar cambios</button>
    <button class="cf-lnk" [routerLink]="['/home']">Cancelar</button>
  </div>

</div>

<loading-indicator *ngIf="isLoading"></loading-indicator>
